module.exports = __webpack_public_path__ + "img/Tsoft.3a832a07.png";